// NOTE: this enum is a convenience for type-narrowing setting names at call sites.
// It is NOT the source of truth for which settings are exposed to the frontend —
// that is controlled by `screener_setting_definitions.is_fe_readable` in the DB.
// Consult the DB (or Retool) when introducing or auditing FE-exposed settings.
export enum ScreenerSettingName {
  NameSearchLastFirst = 'name_search_last_first',
  HchbDynamicPayorForms = 'hchb_dynamic_payor_forms',
  AutoAcceptReviewStage = 'auto_accept_review_stage',
  // not in UserFacingScreenerSettings — ENG-15866
  LostReferralCleanUp = 'lost_referral_clean_up',
  RuleAndDataPullCategories = 'rule_and_data_pull_categories',
  BedBoardEnabled = 'bed_board',
  LoaAdmissionStatus = 'loa_admission_status',
  OverrideAiAnalysisResult = 'override_ai_analysis_result',
  // not in UserFacingScreenerSettings — ENG-15866
  SkipReferralCreationForSpamFax = 'skip_referral_creation_for_spam_fax',
  SkipReferralCreationForNonReferralFax = 'skip_referral_creation_for_non_referral_fax',
  DisableExacareFrontend = 'disable_exacare_frontend',
  PushConditionsToPcc = 'push_conditions_to_pcc',
  PccAllergiesContactsConditionsPushEnabled = 'pcc_allergies_contacts_conditions_push_enabled',
  ReferralOutbound = 'referral_outbound',
  ScreenerCalendar = 'screener_calendar',
  ReferralOutboundFax = 'referral_outbound_fax',
  HomeHealthPractitioners = 'home_health_practitioners',
  BillingScreenerEnabled = 'billing_screener_enabled',
  EsignEnabled = 'esign_enabled',
  EsignCompletedDocumentSharingEnabled = 'esign_completed_document_sharing_enabled',
  EsignRequestCreationEnabled = 'esign_request_creation_enabled',
  BulkDocumentUpload = 'bulk_document_upload',
  DocumentRenaming = 'document_renaming',
  // not in UserFacingScreenerSettings — ENG-15866
  FacilityTypeAdmissionStatusResolution = 'facility_type_admission_status_resolution',
  ShowReferralsBeyondAccess = 'show_referrals_beyond_access',
  DefaultPrimaryOwnerOnReviewStageChange = 'default_primary_owner_on_review_stage_change',
  ServiceAreaEnabled = 'service_area_enabled',
  DisplayInnOonStatus = 'display_inn_oon_status',
  InnOonEnabled = 'inn_oon_enabled',
  ExpandedPayerListRatio = 'expanded_payer_list_ratio',
  PhoneAgent = 'phone_agent',
  WaitlistEnabled = 'waitlist_enabled',
  NoBedSelectionBedboard = 'no_bed_selection_bedboard',
  PalReauths = 'pal_reauths',
  PalReauthNotesEnabled = 'pal_reauth_notes_enabled',
  PccDataRelayEnabled = 'pcc_data_relay_enabled',
  PccBackgroundExtraction = 'pcc_background_extraction',
  PccSourcedDocumentsEnabled = 'pcc_sourced_documents_enabled',
  PccSyncV2Enabled = 'pcc_sync_v2_enabled',
  PalPreauth = 'pal_preauth',
  PalPreauthBenefitsVerificationRequired = 'pal_preauth_benefits_verification_required',
  ScreenerCriteriaCountLimit = 'screener_criteria_count_limit',
  ScreenerMedicationRulesCountLimit = 'screener_medication_rules_count_limit',
  KanbanPresetBar = 'kanban_preset_bar',
  FacTagCriteriaTargeting = 'fac_tag_criteria_targeting',
  CustomFacilityTags = 'custom_facility_tags',
  LeadExchange = 'lead_exchange',
  SourceMerging = 'source_merging',
  HomeHealthCertification = 'home_health_certification',
  AidinHospitalChatEnabled = 'aidin_hospital_chat_enabled',
  HospitalChatMissingInfoFollowUp = 'hospital_chat_missing_info_follow_up',
  SsoGroupMappingAdmin = 'sso_group_mapping_admin',
  ReferralCareAttributeEnabled = 'referral_care_attribute_enabled',
  MatrixCareHomeHealthAddAdmission = 'matrix_care_home_health_add_admission',
  SkipOccupancySubsystem = 'skip_occupancy_subsystem',
  PalCarveOuts = 'pal_carve_outs',
  PalCoverSheets = 'pal_cover_sheets',
  PalCarveOutDailyPriceDefaults = 'pal_carve_out_daily_price_defaults',
  ReviewStageAdmissionSync = 'review_stage_admission_sync',
  HchbPerBranchScoping = 'hchb_per_branch_scoping',
  ScreenerNameFormat = 'screener_name_format',
  ResidentsNameSort = 'residents_name_sort',
  BulkSourceMerging = 'bulk_source_merging',
  ShowOffenderDobMismatch = 'show_offender_dob_mismatch',
  TaskWorkflowsEnabled = 'task_workflows_enabled',
  LegacyReferralTasks = 'legacy_referral_tasks',
  InboundDocuments = 'inbound_documents',
  ShadowAdmissionInsuranceRulesConfig = 'shadow_admission_insurance_rules_config',
  DataCenterV3 = 'data_center_v3',
  PatientJourneyTab = 'patient_journey_tab',
  AdmissionsBoard = 'admissions_board',
  MedicaidPendingEnabled = 'medicaid_pending_enabled',
  ReferralsTableRedesign = 'referrals_table_redesign',
  NotificationsDeleteAll = 'notifications_delete_all'
}
